import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export default function currencyMask(rawValue) {
  const numDecimals = 2;
  const numberMask = createNumberMask({
    prefix: '',
    decimalSymbol: '.',
    includeThousandsSeparator: true,
    allowDecimal: true,
    requireDecimal: true,
    allowLeadingZeroes: false,
    decimalLimit: 2, // how many digits allowed after the decimal
    integerLimit: 7, // limit length of integer numbers
    allowNegative: false,
  });
  const mask = numberMask(rawValue);

  const decimalsRegex = /\.([0-9]{1,2})/;
  const result = decimalsRegex.exec(rawValue);
  // In case there is only one decimal
  let numZerosToAdd = 0;
  if (result && result[1].length < numDecimals)
    numZerosToAdd = numDecimals - result[1].length;
  else if (!result) numZerosToAdd = numDecimals;

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < numZerosToAdd; i++) {
    mask.push('0');
  }

  return mask;
}

export function formatCurrency(rawValue) {
  // Format the number as a currency value
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (!rawValue) {
    return formatter.format(0.0);
  }
  // Remove any non-numeric characters (except for decimal point)
  const cleanedValue = rawValue.toString().replace(/[^\d.]/g, '');

  // Parse the cleaned value as a float
  const floatValue = parseFloat(cleanedValue);

  // Check if the parsed value is a valid number
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(floatValue)) {
    return '';
  }

  return formatter.format(floatValue);
}

export function unformatCurrency(formattedValue) {
  // Return 0 if the input is falsy (null, undefined, empty string, etc.)
  if (!formattedValue) {
    return 0;
  }

  // Remove commas (grouping separators) from the formatted value
  const cleanedValue = formattedValue.toString().replace(/,/g, '');

  // Parse the cleaned value as a float
  const numberValue = parseFloat(cleanedValue);

  // Return the parsed number or 0 if it's not a valid number
  // eslint-disable-next-line no-restricted-globals
  return isNaN(numberValue) ? 0 : numberValue;
}
